import { useHierarchyContext } from "contexts/AppSettingsContext";
import { getHierarchyBaseUrl } from "contexts/hierarchy/getHierarchyBaseUrl";
import { ActiveNavLink } from "../common/ActiveNavLink";

/**
 * Navigation links for ARS (Analysis Results Standard) entities.
 * Shows links for Analysis Methods, Analysis Sets, Data Subsets, and Grouping Factors
 * when ARS is enabled for the hierarchy.
 */
export const ArsLinks = (): React.ReactElement | null => {
  const hierarchyContext = useHierarchyContext();

  // Only show ARS links when arsEnabled is true
  const arsEnabled = hierarchyContext?.hierarchy?.arsEnabled;

  return !hierarchyContext?.hierarchy || !arsEnabled ? null : (
    <>
      <div>
        <ActiveNavLink
          id="hierarchylinks-analysis-methods"
          to={`${getHierarchyBaseUrl(hierarchyContext.hierarchy)}/AnalysisMethods`}
        >
          Analysis methods
        </ActiveNavLink>
      </div>
      <div>
        <ActiveNavLink
          id="hierarchylinks-analysis-sets"
          to={`${getHierarchyBaseUrl(hierarchyContext.hierarchy)}/AnalysisSets`}
        >
          Analysis sets
        </ActiveNavLink>
      </div>
      <div>
        <ActiveNavLink
          id="hierarchylinks-data-subsets"
          to={`${getHierarchyBaseUrl(hierarchyContext.hierarchy)}/DataSubsets`}
        >
          Data subsets
        </ActiveNavLink>
      </div>
      <div>
        <ActiveNavLink
          id="hierarchylinks-grouping-factors"
          to={`${getHierarchyBaseUrl(hierarchyContext.hierarchy)}/GroupingFactors`}
        >
          Grouping factors
        </ActiveNavLink>
      </div>
    </>
  );
};

ArsLinks.displayName = "ArsLinks";
